import { Player } from '@lottiefiles/react-lottie-player';
import React from 'react';
import SalesforceCloudOutlineJson from 'images/SalesforceCloudOutline.json';

export interface SalesforceCloudOutlineProps {
	className?: string;
}

export const SalesforceCloudOutline: React.FC<SalesforceCloudOutlineProps> = (props) =>
	<Player
		{ ...props }
		autoplay
		loop
		src={ SalesforceCloudOutlineJson } />;

